import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class RecoverPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                clave: null,
                claveReingresada: null,
                claveActivacionCodigo: props.match.params.activationKey,
            },
            persona: null,
            activationKeyValid: null,
            passwordCreated: null,
            redirectTo: null,
            errors:[],
            loading: false,
            countdownRedirect: 15 // DEVOPS FIX: Temporizador de escape
        }
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loginRandom = null;
        this.redirectTimer = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey && ConfigBusiness.get(visibilityConfigKey) === "false") return null;
        const slug = ConfigBusiness.get("generales.clienteSlug");
        if (slug && slug !== "false" && slug !== "default") return `${process.env.PUBLIC_URL}/images/branding/${slug}/${defaultFilename}`;
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    // DEVOPS FIX: Cuenta regresiva para auto-escape
    startRedirectTimer = () => {
        if (this.redirectTimer) clearInterval(this.redirectTimer);
        this.setState({ countdownRedirect: 15 });
        this.redirectTimer = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.countdownRedirect <= 1) {
                    clearInterval(this.redirectTimer);
                    this.handleGoHome();
                    return { countdownRedirect: 0 };
                }
                return { countdownRedirect: prevState.countdownRedirect - 1 };
            });
        }, 1000);
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.clave': (value) => Validator.notEmpty(value),
                'formData.claveReingresada': (value) => Validator.notEmpty(value)
            }
        });
    }

    componentWillUnmount() {
        if (this.redirectTimer) clearInterval(this.redirectTimer);
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        fetch(Config.get('apiUrlBase') + '/public/auth/persona/' + this.state.formData.claveActivacionCodigo , {
            method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    this.setState({ persona: data, activationKeyValid: true }, () => { if(this.refs.clave) this.refs.clave.focus(); });
                });
            } else if(response.status === 400) {
                response.json().then(data => {
                    // DEVOPS FIX: Disparamos timer si el link es viejo/inválido
                    this.setState({ errors: data.detalle, activationKeyValid: false }, () => {
                        this.startRedirectTimer();
                    });
                }).catch(() => this.error());
            } else { this.error(); }
        }).catch(() => this.error()).finally(() => this.setState({ loading: false }));
    }

    handleFormChange(event) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[event.target.name] = event.target.value;
        this.setState({ formData: formDataCopy, errors:[] });
    }

    handleSubmit(event) {
        event.preventDefault();
        if(this.state.formData.clave !== this.state.formData.claveReingresada) {
            this.setState({ errors:['recoverPassword.errors.contrasenias_coinciden'] });
        } else {
            this.setState({ loading: true, errors:[] });
            fetch(Config.get('apiUrlBase') + '/public/auth/activate/' + this.state.formData.claveActivacionCodigo, {
                method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...this.state.formData }),
            }).then(response => {
                if(response.status === 200) {
                    this.setState({ passwordCreated: true });
                } else if(response.status === 400) {
                    response.json().then(data => this.setState({ errors: data.detalle })).catch(() => this.error());
                } else { this.error(); }
            }).catch(() => this.error()).finally(() => this.setState({ loading: false }));
        }
    }

    handleGoHome() { this.setState({ redirectTo: '/' }); }

    error() {
        swal("Error", "Contacte al administrador.", "error");
    }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoAppSrc = this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");

        return (
            <React.Fragment>
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={`${process.env.PUBLIC_URL}/images/images-login/image${this.loginRandom}.png`}>
                                <source src={`${process.env.PUBLIC_URL}/images/videos-login/video${this.loginRandom}.mp4`} type="video/mp4"/>
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '380px'}}>
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>
                                            
                                            <div className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                                <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '90px', objectFit: 'contain' }} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-app.png"; }} />
                                            </div>

                                            <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem'}}>
                                                {this.state.activationKeyValid === true && !this.state.passwordCreated ? (
                                                    <React.Fragment>
                                                        <h5 className="text-center font-weight-bold text-muted mb-2"><FormattedMessage id="recoverPassword.cambio_contrasenia" defaultMessage="Cambio de contraseña"/></h5>
                                                        <p className="text-center text-muted mb-2" style={{fontSize: '13px'}}>
                                                            <FormattedMessage id="recoverPassword.information.bienvenido" defaultMessage="Bienvenido "/><b>{this.state.persona.nombre + ' ' + this.state.persona.apellido}</b>. <br/><FormattedMessage id="recoverPassword.information.nombre_de_usuario" defaultMessage="Su usuario es "/><b>{this.state.persona.usuario}</b>.
                                                        </p>
                                                        
                                                        <form className="form-horizontal" noValidate onSubmit={this.handleSubmit}>
                                                            <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                <input type="password" className="form-control" style={{borderRadius: '8px', height:'42px'}} name="clave" placeholder="Contraseña nueva" ref="clave" required onChange={this.handleFormChange} maxLength="16" />
                                                                <div className="form-control-position" style={{top:'1px'}}><i className="la la-key"></i></div>
                                                            </fieldset>
                                                            <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                <input type="password" className="form-control" style={{borderRadius: '8px', height:'42px'}} name="claveReingresada" placeholder="Reingrese la contraseña" required onChange={this.handleFormChange} maxLength="16" />
                                                                <div className="form-control-position" style={{top:'1px'}}><i className="la la-key"></i></div>
                                                            </fieldset>

                                                            <div className="text-center mb-1" hidden={this.state.errors.length===0} style={{minHeight:'18px'}}>
                                                                <small className="text-danger font-weight-bold">{this.state.errors.map((e, i) => <span key={i}><FormattedMessage {...(backendStrings[e] || {id:e, defaultMessage:e})}/> </span>)}</small>
                                                            </div>

                                                            <div className="alert alert-info p-2 mt-2 text-left" style={{borderRadius: '8px', fontSize: '11px'}} role="alert">
                                                                <strong><FormattedMessage id="auth.pass_req" defaultMessage="Requisitos:" /></strong><br/>
                                                                - <FormattedMessage id="auth.pass_req1" defaultMessage="Entre 8 y 16 caracteres." /><br/>
                                                                - <FormattedMessage id="auth.pass_req2" defaultMessage="Al menos un número y una letra." /><br/>
                                                                - <FormattedMessage id="auth.pass_req3" defaultMessage="Símbolos permitidos:" /> . ! ¿ ? @ $ & # % * + - _ =
                                                            </div>

                                                            <button type="submit" className="btn btn-primary btn-block shadow-sm mt-2" style={{borderRadius: '8px', height:'42px', fontWeight: '500'}} disabled={!validationState.form.valid}>
                                                                <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-check'}></i> <FormattedMessage id="auth.guardar" defaultMessage="Guardar" />
                                                            </button>
                                                        </form>
                                                    </React.Fragment>
                                                ) : this.state.activationKeyValid === false && !this.state.passwordCreated ? (
                                                    
                                                    /* DEVOPS FIX: PANTALLA ENLACE INVÁLIDO PROLIJA Y TRADUCIBLE */
                                                    <div className="text-center py-2">
                                                        <div className="mb-2"><i className="la la-exclamation-circle" style={{fontSize: '55px', color:'#d9534f'}}></i></div>
                                                        <h5 className="font-weight-bold text-danger mb-2">
                                                            <FormattedMessage id="auth.enlace_invalido_title" defaultMessage="Enlace Inválido" />
                                                        </h5>
                                                        <p className="text-muted mb-1" style={{fontSize:'13px', lineHeight: '1.5'}}>
                                                            <FormattedMessage id="auth.enlace_expiro" defaultMessage="El enlace expiró o es incorrecto." /><br/>
                                                            <FormattedMessage id="auth.contacte_admin_blanqueo" defaultMessage="Contacte al administrador o solicite un nuevo blanqueo de contraseña." />
                                                        </p>
                                                        
                                                        <div className="mt-4">
                                                            <div className="progress mb-2" style={{height: '4px', borderRadius:'2px'}}>
                                                                <div className="progress-bar bg-danger" style={{width: `${(this.state.countdownRedirect / 15) * 100}%`, transition: 'width 1s linear'}}></div>
                                                            </div>
                                                            <small className="text-muted d-block mb-2">
                                                                <FormattedMessage id="auth.redirigiendo_en" defaultMessage="Redirigiendo al login en {seconds}s..." values={{seconds: this.state.countdownRedirect}} />
                                                            </small>
                                                            <button className="btn btn-outline-danger btn-block shadow-sm mt-2" style={{borderRadius: '8px'}} onClick={this.handleGoHome.bind(this)}>
                                                                <i className="la la-arrow-right"></i> <FormattedMessage id="auth.ir_al_login" defaultMessage="Ir al Login" />
                                                            </button>
                                                        </div>
                                                    </div>

                                                ) : this.state.passwordCreated ? (
                                                    <div className="text-center py-2">
                                                        <i className="la la-check-circle" style={{fontSize: '65px', color:'#00c0bd'}}></i>
                                                        <h5 className="font-weight-bold mt-2 text-success"><FormattedMessage id="recoverPassword.information.contrasenia_modificada" defaultMessage="¡Contraseña modificada!"/></h5>
                                                        <button className="btn btn-outline-primary btn-block mt-4 shadow-sm" style={{borderRadius: '8px'}} onClick={this.handleGoHome.bind(this)}>
                                                            <FormattedMessage id="recoverPassword.information.acceder_fleet" defaultMessage="Ir al Inicio"/>
                                                        </button>
                                                    </div>
                                                ) : null}

                                                <div className="mt-3 pt-3" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">{logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-company.png"; }} />}</div>
                                                        <div className="col-6 text-right">{logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '30px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-powered-by.png"; }} />}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl(RecoverPassword);
